function loadImage(file) {
  return new Promise((resolve, reject) => {
    const url = URL.createObjectURL(file);
    const img = new Image();
    img.onload = () => {
      URL.revokeObjectURL(url);
      resolve(img);
    };
    img.onerror = () => {
      URL.revokeObjectURL(url);
      reject(new Error('Could not read this photo. Please retake it.'));
    };
    img.src = url;
  });
}

/**
 * Shrinks a camera photo to at most `maxSide` px on the long edge and returns a
 * JPEG data URL. Kept fairly large so odometer digits stay readable for OCR.
 */
export async function compressImage(file, { maxSide = 1600, quality = 0.8 } = {}) {
  if (!file || !String(file.type || '').startsWith('image/')) {
    throw new Error('Please take a photo of the meter.');
  }
  const img = await loadImage(file);
  const scale = Math.min(1, maxSide / Math.max(img.naturalWidth, img.naturalHeight));
  const width = Math.max(1, Math.round(img.naturalWidth * scale));
  const height = Math.max(1, Math.round(img.naturalHeight * scale));

  const canvas = document.createElement('canvas');
  canvas.width = width;
  canvas.height = height;
  const ctx = canvas.getContext('2d');
  ctx.drawImage(img, 0, 0, width, height);
  return canvas.toDataURL('image/jpeg', quality);
}
